import React from 'react';

const Footer = () => (
  <footer className="bg-slate-900 dark:bg-slate-950 text-white mt-32 py-16 text-center border-t dark:border-slate-800 transition-colors font-black">
    <p className="text-2xl mb-4 tracking-tighter uppercase">DeepVision Hub</p>
    <p className="text-slate-500 text-xs uppercase tracking-[0.4em]">© 2025 Excellence Industrielle</p>
  </footer>
);

export default Footer;
